import { generatePath, useOutletContext } from 'react-router-dom';

import { PayoutType } from 'types';
import { Messages, AppRoutes } from 'config';
import { TransactionsList } from 'components';
import { Payout, useDeleteMutation } from 'store/api/payout';
import {
  isMobile,
  useFilter,
  useShowMore,
  useNavigate,
  useSearchQuery,
  handleMutation,
} from 'hooks';

import { OutletContext } from '../../types';
import {
  getCommonListProps,
  advanceBonusCellsMobile,
  getAdvanceBonusExtendRender,
} from '../config';

const { New, Details } = AppRoutes.Profile.Advances;

export const Advances = () => {
  const mobile = isMobile();
  const navigate = useNavigate();
  const { payout, isCompanyOwner } = useOutletContext<OutletContext>();

  const { debounceQuery, ...search } = useSearchQuery();
  const filteredData = useFilter<Payout>({
    query: debounceQuery,
    data: payout?.advances || [],
    paths: ['event.name', 'amount', 'notes'],
  });

  const [remove, mutation] = useDeleteMutation();
  handleMutation({
    ...mutation,
    successMessage: `Advance ${Messages.DELETED_SUCCESSFULLY}`,
  });

  const { visibleData, ...showMoreProps } = useShowMore(filteredData);

  return (
    <TransactionsList
      {...getCommonListProps(filteredData)}
      createPath={New}
      title="Advances"
      data={visibleData}
      isFooterCreateButton
      cellsMobile={advanceBonusCellsMobile}
      listProps={{ ...search, ...showMoreProps }}
      createTitle={isCompanyOwner ? 'New advances' : undefined}
      template={isCompanyOwner ? '1fr 3fr 1fr 1fr 1fr 184px' : undefined}
      onClick={(e, value) =>
        navigate(generatePath(Details, { advanceId: value.id }))
      }
      extendRender={getAdvanceBonusExtendRender({
        mobile,
        remove,
        isCompanyOwner,
        type: PayoutType.Advance,
      })}
    />
  );
};
